module.exports = __webpack_public_path__ + "teqbahn-assets/media/20.6141fc91.png";